import React, { useState} from 'react'
import Users from '../data/Users.json'
import { useSelector } from 'react-redux'
import Modal from 'react-modal';
import { IoSettingsSharp } from "react-icons/io5";
import { AiFillCloseCircle } from "react-icons/ai";


export default function ProfileChanges() {
    const user = useSelector((state) => state.user)

    const index=user.userId-1

    const userinfo=Users[index]

    
    




    // let subtitle;
    const [modalIsOpen, setIsOpen] = useState(false);
    const [form, setForm] = useState({});

    function openModal() {
        setIsOpen(true);
    }



    function closeModal() {
        setIsOpen(false);
    }

    function submitHandler(e) {
        e.preventDefault();
        const index=user.userId-1

        if(form.name){
            Users[index].userName=form.name
        }
        else{
            Users[index].userName=userinfo.userName 
        }

        if(form.email){
            Users[index].email=form.email
        }
        else{
            Users[index].email=userinfo.email 
        }

        if(form.pic){
            Users[index].userImage=form.pic
        }
        else{
            Users[index].userImage=userinfo.userImage 
        }

        
        
        
    }
    function onChangeHandler(event) {
        const name = event.target.name;
        const value = event.target.value;
        setForm((values) => ({ ...values, [name]: value }));


    }

    return (
        <div className='h-full  flex md:pt-28 pt-16 p-3 bg-no-repeat bg-cover' style={{backgroundImage: `url(${userinfo.userImage})`}}>

            <div className='w-full  h-full bg-shasham backdrop-blur-lg bg-opacity-70 rounded-lg '>
                <div className='border-4 border-dwam bg-indigo-500 rounded-full w-fit mx-auto md:-mt-24 -mt-12'>
                    <div onClick={openModal} className='cursor-pointer bg-yakam absolute w-5 h-5 mt-12 ml-16 md:w-9 md:h-9 rounded-full items-center flex md:mt-28 md:ml-36'><IoSettingsSharp className='md:w-5 md:h-5 mx-auto text-c7' /></div>
                    <img className='rounded-full w-20 h-2w-20 md:w-44 md:h-44 object-contain' src={userinfo.userImage} alt={userinfo.userImage} />
                </div>
                <div className='flex flex-row-reverse p-2 '>

                    <div className='flex flex-col text-right w-full'>
                        <h1 className=' text-center md:text-3xl text-yakam text-md'>{userinfo.userName}</h1>
                        <div className=' p-2 text-sm md:text-lg'>
                            <h1 className='text-yakam'>: ناو</h1>
                            <p className='md:text-base text-yakam text-xs' >{userinfo.userName}</p>
                            <h1 className='text-yakam'>: هەژماری ئەلئکترۆنی</h1>
                            <p className='md:text-base text-yakam text-xs' >{userinfo.email}</p>
                        </div>
                    </div>
                </div>

            </div>

            <div className='bg-red-600'>
                {/* <button onClick={openModal}>edit username</button> */}
                <Modal
                    isOpen={modalIsOpen}
                    // onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    // style={customStyles}
                    contentLabel="Example Modal"
                    className={'bg-slate-800 p-3 w-2/3 h-fit absolute top-[15%] bottom-[15%] left-[15%] right-[15%]'}
                >

                    <button onClick={closeModal}><AiFillCloseCircle className='text-red-900 w-5 h-5' /></button>
                    <form onSubmit={submitHandler}>

                        <div className='flex flex-col'>
                            <div className='flex md:flex-row-reverse md:flex-wrap flex-col md:justify-evenly text-gray-300  w-full'>

                                <div className=" ">
                                    <div className='w-full  flex justify-end p-3 '>
                                        <label htmlFor="name" className=" text-right " id="">
                                            ناو
                                        </label>
                                    </div>
                                    <input className="bg-slate-700 rounded-3xl w-full"
                                        name="name"
                                        id="name"
                                        type="text"
                                        required=""
                                        value={form.name || userinfo.userName}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                                <div className=" ">
                                    <div className='w-full  flex justify-end p-3 '>
                                        <label htmlFor="name" className=" text-right " id="">
                                            هەژماری ئەلئکترۆنی
                                        </label>
                                    </div>
                                    <input className="bg-slate-700 rounded-3xl w-full"
                                        name="email"
                                        id="email"
                                        type="email"
                                        required=""
                                        value={form.email || userinfo.email}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                                <div className=" ">
                                    <div className='w-full flex-col flex justify-end p-2 '>
                                        <label htmlFor="name" className=" text-right " id="">
                                            وێنەی پڕۆفایل
                                        </label>

                                        <p className='text-sm text-yellow-300 text-right'><span className='text-red-500 text-base'>*</span>پێویستە لینکی وێنەکە دابنێیت لەناو بۆشایەکەی خوارەوە</p>
                                    </div>
                                    <input className="bg-slate-700 rounded-3xl w-full"
                                        name="pic"
                                        id="pic"
                                        type="text"
                                        required=""
                                        value={form.pic || userinfo.userImage}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                            </div>
                            <div className='mx-auto w-1/2 m-3 flex justify-center'>
                                <button type='submit' className="mx-auto shadow-sm shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-full overflow-hidden text-sm font-medium text-gray-300 rounded-lg group bg-gradient-to-br from-cyan-500 to-emerald-500 group-hover:from-cyan-500 group-hover:to-emerald-500 hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                                    <span className="shadow-sm shadow-penjam relative w-full px-5 py-2.5 transition-all ease-in duration-75 bg-slate-700  rounded-md group-hover:bg-opacity-0">
                                        خەزنکردن
                                    </span>
                                </button>
                            </div>

                        </div>
                    </form>

                </Modal>
            </div>
        </div>
    )
}

